import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useDataAssetColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const name = cols.define(component, 'name', i18n.t('misc.name'), true)
	const instance = cols.define(component, 'instance_id', i18n.t('institution'), true)
	const responsible = cols.define(component, 'responsible', i18n.t('responsible'), true)
	const date = cols.define(component, 'date', i18n.t('date.date'), true)
	const hasPersonalData = cols.define(component, 'has_personal_data', i18n.t('hasPersonalData'), true)
	const location = cols.define(component, 'location', i18n.t('location'), true)
	const risks = cols.define(component, 'risks', i18n.t('risk.count'), true)

	const columns = { name, instance, responsible, date, hasPersonalData, location, risks }

	const { custom, all } = cols.finalize(component, columns, true, ['data_assets'])

	return { columns, custom, all }
}
